import Translate from '../../i18n/Translate'
//Comps
import ServicesSlider from '../../components/Home/ServicesSlider'
//Intersection
import { useInView } from 'react-intersection-observer'

const Services = () => {
    const [serviceIntro, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    })

    return (
        <section className="incoming-home__services">
            <div className={`intro animate slide-right ${inView ? 'in-view' : ''}`} ref={serviceIntro}>
                <h2>
                    <Translate langkey="home.services.title" />
                </h2>
                <p>
                    <Translate langkey="home.services.copy" />
                </p>
            </div>
            <div className="services-slider-wrapper">
                <ServicesSlider />
            </div>
        </section>
    )
}

export default Services
